<template>
  <HeaderBar
    :is-cps="isCps"
    :source="skuActivateInfo?.activityType === 1 ? 1 : 0"
    :id="currentSelectedSKU ? currentSelectedSKU.skuId : listingDetail.listingId"\
    :listing-id="listingDetail.listingId"
    :product-image="listingDetail?.imageUrls[0] || ''"
    :product-name="listingDetail?.title || ''"
    :is-wish="listingDetail.beenFollowed"
    :trackBaseData="baseTrackData"
    @update:show-bar="handleUpdateShowBarChange"
  />

  <div class="swiper-box" id="product" :class="{ 'app-entry-disabled': isCps || isTiktok().value }">
    <SwiperImage :images="listingDetail.imageUrls" :videoUrl="listingDetail.dashVideoUrl || listingDetail.videoUrl" :imgTitle="listingDetail.title" />
    <div class="back" @click="$router.back()"><van-icon name="arrow-left" color="#fff" /></div>
    <ClientOnly>
      <QuickOperations
        :is-cps="isCps"
        :listing-id="listingDetail.listingId"
        :sku-id="currentSelectedSKU?.skuId"
        :product-image="listingDetail?.imageUrls[0] || ''"
        :product-name="listingDetail?.title || ''"
        :is-wish="listingDetail.beenFollowed"
        :trackBaseData="baseTrackData"
        @to:chat="handleTokfClick"
        @add:wish="handleAddWishClick"
      />
    </ClientOnly>
  </div>

  <div
    v-if="skuActivateInfo && [1, 4, 6].includes(skuActivateInfo?.activityType)"
    class="activate-card"
  >
    <ActivateCountdownCard
      :key="activityKey(skuActivateInfo)"
      @countdown:over="handleActivityOver"
      :options="{
        queryTime: skuActivateInfo.queryTime,
        endTime: skuActivateInfo.endTime,
        startTime: skuActivateInfo.startTime
      }"
      :activityInfo="skuActivateInfo"
    />
  </div>

  <div class="content-wrapper">
    <div class="info-card basic-info">
      <!-- 活动商品 -->
      <template v-if="skuActivateInfo && [1, 4, 6].includes(skuActivateInfo?.activityType)">
        <span class="sale-price">{{ $currencySymbol() }} {{ $toThousandsFn(skuActivateInfo.activityPrice) }}</span>

        <span class="del-price" v-if="skuActivateInfo.activityPrice !== skuPrice.listPrice">
          {{ $currencySymbol() }} {{ $toThousandsFn(skuPrice.listPrice) }}
          <ClientOnly><span v-if="activateDiscount > 0 && activateDiscount < 100" class="discount">(-{{ activateDiscount }}%)</span></ClientOnly>
        </span>
      </template>
      <!-- 普通商品 -->
      <template v-else>
        <span class="sale-price">{{ $currencySymbol() }} {{ $toThousandsFn(skuPrice.salePrice) }}</span>

        <span class="del-price" v-if="skuPrice.salePrice !== skuPrice.listPrice">
          {{ $currencySymbol() }} {{ $toThousandsFn(skuPrice.listPrice) }}
          <ClientOnly><span v-if="skuPrice.discount > 0 && skuPrice.discount < 100" class="discount">(-{{ skuPrice.discount }}%)</span></ClientOnly>
        </span>
      </template>

      <KilimallChoice v-if="showKilimallChoice" />
      
      <div class="promotion-bo">
        <PromotionCard :isFlashSale="skuActivateInfo?.activityType === 1" :promotion-info="promotionInfo" />
      </div>

      <h1 class="product-title">{{ listingDetail.title }}</h1>

      <a href="#reviews">
        <div class="cell-box cell-box-bl">
          <div class="reviews-info">
            <van-rate :model-value="Number(reviewScore)" class="reviews-star" color="#f76900" />&nbsp;{{ reviewScore }}
            &nbsp;|&nbsp;
            <span>Reviews({{ reviewTotal }})</span>
          </div>

          <span class="icon"><van-icon name="arrow" size="14" /></span>
        </div>
      </a>

      <p v-if="listingDetail.prepayment.state !== -1">
        <span class="prepaid-tips">
          This product supports {{ NP.times(listingDetail.prepayment.prepaymentRatio, 100).toFixed(2) }}% prepaid.
        </span>
      </p>

      <p v-if="storeInfo && storeInfo?.store.status !== 1" class="store-closed-tips">
        Tips: The store is not in service now.
      </p>

      <div @click="handleOrderNowClick('switch-sku')">
        <div class="cell-box sku-cell-box">
          <div class="sku-specs">{{ specsPreview }}</div>
          <span class="icon"><van-icon name="arrow" size="14" /></span>
        </div>
        <div class="small-image-box" v-if="colorSpec && colorSpec.values.length > 0">
          <div
            v-for="(item, index) in colorSpec.values"
            :key="index"
            class="small-image"
            v-show="!item.disabledRemoved"
            :select="specsKeyPreview.indexOf(`${colorSpec.pid}:${item.pvid}`) >= 0 ? '1' : '0'"
          >
            <img :src="item.image || useImg1pxBase64().value" alt="" :lazy="!item.image ? 'error' : 'loaded'" />
          </div>
        </div>
      </div>

    </div>

    <div v-if="voucherList.show || gifts.length > 0" class="info-card cell-title-card">
      <div class="cell-box">
        <p class="title">Promotions</p>
      </div>
      
      <div v-if="voucherList.show" class="cell-box voucher-list" @click="handleShowVoucherClick">
        <div>
          <span v-for="voucher in voucherList.list.slice(0, 2)" :key="voucher.genId" class="voucher">
            {{ $currencySymbol() }}
            {{ $toThousandsFn(voucher.amount) }}
            <i></i>
          </span>
        </div>
        <span class="icon">
          {{ isExtremeDiversion ? 'Claim it in Kilimall APP' : 'Claim Now' }}&nbsp;<van-icon name="arrow" size="14" />
        </span>
      </div>

      <div class="gifts" v-if="gifts.length > 0">
        <KGiftsCard :gifts="gifts" />
      </div>
    </div>

    <div class="info-card cell-title-card">
      <div class="cell-box" @click="handleSwitchAddressClick">
        <p class="title">Shipping to</p>
        <div class="icon">
          <span class="address-name">{{ selectedAddress?.areaNameList?.map(c => c.name).join(',') }}</span>
          <van-icon name="arrow" size="14" />
        </div>
      </div>

      <div class="delivery-infos">
        <DeliveryCard
          :shippingTimeDescription="deliveryInfo?.shippingTimeDescription || ''"
          :delivery="deliveryCardInfo"
          :logistics-type="deliveryInfo?.logisticsType"
        />
      </div>
    </div>

    <div
      v-if="reviewsList && reviewsList.length"
      class="info-card cell-title-card"
      id="reviews"
    >
      <div class="cell-box" @click="handleToReviewsClick">
        <p class="title">Customer reviews({{ reviewTotal }})</p>
        <span v-if="!isExtremeDiversion" class="icon">View All&nbsp;<van-icon name="arrow" size="14" /></span>
      </div>

      <ClientOnly v-if="isExtremeDiversion">
        <a
          :href="reviewsDeepLinkUrl"
          class="find-more-reviews"
          @click="handleOpenAppClick"
        >
          <span>Find more reviews in Kilimall APP</span>
          <van-icon name="arrow" size="14" />
        </a>
      </ClientOnly>

      <div class="review-list">
        <KReviewsItem 
          v-for="reviewItem in reviewsList"
          :key="reviewItem.commentContent?.id"
          :review-item="reviewItem"
          :traffic-track="reviewTrafficTrack"
          :hiddenReply="true"
          :showOptionsBar="false"
        />
      </div>
    </div>

    <div v-if="!isCps" class="info-card cell-title-card">
      <div class="store-card-box">
        <StoreCard :store="storeInfo?.store" @to:chat="handleTokfClick" />
      </div>

      <div class="cell-box">
        <p class="title">Store Selective</p>
      </div>

      <Recommend :listings="storeRecommendListings" />
    </div>

    <div class="info-card" id="description">
      <ClientOnly>
        <a
          v-if="isExtremeDiversion"
          :href="descriptionDeepLinkUrl"
          class="find-more-details"
          @click="handleOpenAppClick"
        >
          <span>Find more details in Kilimall APP</span>
          <van-icon name="arrow" size="14" />
        </a>
      </ClientOnly>
      <template v-if="!isExtremeDiversion">
        <KProductDetailSpecification :specification="specification" />
        <KProductDetailRichText :detailItems="listingDescription" />
        <div class="box-description" v-if="listingDetail?.box">
          <div class="cell-box"><p class="title">What's in the box</p></div>
          <p>{{ listingDetail.box }}</p>
        </div>
      </template>
    </div>

    <div v-if="!isCps" class="info-card cell-title-card recommend-product-box" id="recommend">
      <div class="cell-box"><p class="title">You May Also Like</p></div>
      <ClientOnly>
        <KViewportMount>
          <LazyKRecommendProduct :clsId="clsId" :recommendId="4" :skuIds="currentSkuId ? [currentSkuId] : []" :listing-ids="listingDetail.listingId ? [listingDetail.listingId] : []"/>
        </KViewportMount>
      </ClientOnly>
    </div>
  </div>

  <OperationBar
    :is-cps="isCps"
    :isSupportMergeCommit="listingDetail.prepayment.isSupportMergeCommit"
    :activityProgress="skuActivateInfo?.activityType === 1"
    :isSale="!!currentSelectedSKU?.skuId"
    :listing-id="listingDetail.listingId"
    :tips="flashSaleOutStockTips"
    :storeId="storeInfo?.store?.storeAlias || storeInfo?.store?.id"
    :is-wish="listingDetail.beenFollowed"
    :show-app-bar="isShowOpenAppBar"
    :app-link-id="currentSelectedSKU ? currentSelectedSKU.skuId : listingDetail.listingId"
    :app-link-source="skuActivateInfo?.activityType === 1 ? 1 : 0"
    @order:now="handleOrderNowClick"
    @to:chat="handleTokfClick"
    @add:wish="handleAddWishClick"
  />

  <ClientOnly>
    <Sku
      :is-cps="isCps"
      v-model:visible="skuVisible"
      v-model:sku-spec="specsPreview"
      v-model:sku-key="specsKeyPreview"

      :visible-type="skuVisibleType"
      :quantity="quantity"
      :sku-activate-info="skuActivateInfo"
      :detail="listingDetail"
      :sku-price="skuPrice"
      :store="storeInfo?.store"
      :current-selected-sku="currentSelectedSKU"
      :gifts="gifts"
      :skus="skus"
      :addressId="selectedAddress?.id"
      :trackBaseData="baseTrackData"
      :bigPromotion="promotionInfo.bigPromotion"
      :address="selectedAddress"
      :user-address-loading="userAddressLoading"
      :delivery-info="deliveryInfo"
      :inventory-status="inventoryStatus"
      @retry:inventory="retryInventory"

      @update:sku="handleUpdateSkuClick"
      @activity:over="handleActivityOver"
      @select:address="handleSwitchAddressClick"
      @update:quantity="handleQuantityChange"
      @arrival-reminder="handleArrivalReminderSuccess"
    />

    <LazyAddressSelectPopup
      v-model:show="addressPopupShow"
      :select-id="userSelectAddressId"
      :address-list="userAddressList" 
      :addressClick="handleAddressClick"
      @update:select-id="handleUpdateSelectAddressId"
    />
    <LazyVoucherCouponPopup
      v-model:visible="couponPopupShow"
      :voucher-list="[listCollect, listCollected]"
      receive-scene="PRODUCT_DETAIL"
      @update:voucher="handleUpdateVoucher"
    />
    <CpsExclusiveCouponPopup
      v-if="cpsCouponAmount !== null"
      v-model:show="cpsCouponPopupShow"
      :amount="cpsCouponAmount"
      :currency-symbol="cpsCouponCurrencySymbol"
      @claim="handleCpsCouponClaim"
      @close="cpsCouponPopupShow = false"
    />
  </ClientOnly>
</template>

<script setup lang="ts">
import { usePurchaseRequests } from './usePurchaseRequests'
import { activityKey } from './purchase'
import {
  getGiftsBySkuId, getInventoryBySkuId,
  getVouchersBySkuids, type IVoucherParmas, getListingByIdV2,
  classifyGoodsDetailFailure,
  getCtgPathByCid, getShippingTime, getGoodsGoogleStructuredData
} from '@/api/models/product'
import { getShippingAddress } from '@/api/models/userInfo'
import { resolveCpsShareLanding, type CpsShareLandingStatus } from '@/api/models/cps'
import { getStoreInfo, getRecommendedProduct } from '@/api/models/store'
import {  getCommentList, getCommentStatistics } from '@/api/models/reviews'
import { 
  setStructuredData, setSEOMeta, LazyQueue, updateStatus, disableOutOfStockSpecs,
  initSkuPrice, trackFn, type ITrackConfig, initSkuId,
  toLiveChatSource,
  buildTrafficSourceTracking,
  tiktokTrack,
  type IListingCategoryItem,
  setReviewListingIdCategoryList
} from './mixins'
import { type IGifts } from '@/components/KGifts/Card.vue'
import NP from 'number-precision'

import HeaderBar from './wap-widgets/HeaderBar.vue'
import SwiperImage from './wap-widgets/SwiperImage.vue'
import DeliveryCard from './wap-widgets/DeliveryCard.vue'
import StoreCard from './wap-widgets/StoreCard.vue'
import Recommend from './wap-widgets/Recommend.vue'
import PromotionCard from './wap-widgets/PromotionCard.vue'
import Sku from './wap-widgets/Sku.vue'
import OperationBar from './wap-widgets/OperationBar.vue'
import QuickOperations from './wap-widgets/QuickOperations.vue'
import ActivateCountdownCard from './wap-widgets/ActivateCountdownCard.vue'
import KilimallChoice from './widgets/KilimallChoice.vue'
import { getUrlCache } from '~/api/models/system'
import { buildSourceMetaFromQuery } from '@/utils/traffic-source'
import {
  trafficTrackToRouteQuery,
  buildProductDetailStoreSpecifiedSource,
  buildShareEntryListingSourceFromQuery,
  resolveIsChoiceTag,
  type ITrafficTrackFields
} from '@/plugins/utils'
import { useWapListingDetailVersionState } from '@/utils/wap-listing-detail-version'
import { ssrMeasure } from '@/utils/ssr-timing'

definePageMeta({ layout: 'wap' })

const queue = new LazyQueue()
const route = useRoute()
const router = useRouter()
const { id: paramsId } = route.params

const [id] = (paramsId as string).split('-')
// const { type,  source, skuId, addressId, from, isAd } = route.query
const nuxtApp = useNuxtApp()
const { $currencySymbol, $tz, $SENSORS_EVENT, $sensors, $getExternalLastTrafficSource, $formatStringToURL } = nuxtApp
const cacheKey = `${id}_${useCookie('kilimall_cache_key').value}`

const rawCpsShareAsset = route.query.cpsShareAsset
const cpsShareAsset = String(Array.isArray(rawCpsShareAsset) ? rawCpsShareAsset[0] || '' : rawCpsShareAsset || '')
const isCps = computed(() => {
  const asset = route.query.cpsShareAsset
  return !!(Array.isArray(asset) ? asset[0] : asset)
})
const cpsPathState = useCpsPathState()
let cpsPathToken = ''
let cpsLandingStatus: CpsShareLandingStatus | null = null
let cpsLandingErrorMessage = ''
let cpsLandingResponse: Awaited<ReturnType<typeof resolveCpsShareLanding>> | null = null
const cpsCouponPopupShow = ref(false)
const cpsCouponAmount = ref<number | string | null>(null)
const cpsCouponCurrencySymbol = computed(() => {
  return $currencySymbol() || (useCurrentCountryCode().value === 'UG' ? 'USh' : 'KSh')
})
const handleCpsCouponClaim = () => {
  cpsCouponPopupShow.value = false
  if(!useUserInfo().value?.accessToken) {
    router.push({ path: '/login', query: { redirect: route.fullPath } })
  }
}

onMounted(() => {
  if (cpsShareAsset) {
    console.log('[CPS] share-landings result (SSR result may be reused)', {
      assetId: cpsShareAsset,
      response: cpsLandingResponse,
      error: cpsLandingErrorMessage || null
    })
  }
  if(cpsLandingErrorMessage) {
    showToast(cpsLandingErrorMessage)
    return
  }

  const shouldPromptLogin = cpsLandingStatus !== null && !useUserInfo().value?.accessToken
  const shouldShowClaimNotice = cpsLandingStatus === 'relationship_established'
    && listingDetail.value.voucherClaimNotice != null

  cpsCouponPopupShow.value = cpsCouponAmount.value !== null && (shouldPromptLogin || shouldShowClaimNotice)
})

if(cpsShareAsset) {
  const cachedPathToken = cpsPathState.value?.assetId === cpsShareAsset
    ? cpsPathState.value.pathToken
    : undefined

  try {
    const landingResponse = await resolveCpsShareLanding(cpsShareAsset, cachedPathToken)
    cpsLandingResponse = landingResponse
    const landingData = landingResponse?.data

    if(landingData && ['relationship_established', 'view_only'].includes(landingData.status)) {
      cpsLandingStatus = landingData.status
      const amount = landingData.coupon?.amount
      if ((typeof amount === 'number' || typeof amount === 'string')
        && Number.isFinite(Number(amount)) && Number(amount) > 0) {
        cpsCouponAmount.value = amount
      }
      if(landingData.pathToken) {
        cpsPathToken = landingData.pathToken
        cpsPathState.value = { assetId: cpsShareAsset, pathToken: landingData.pathToken }
      } else if(cpsPathState.value?.assetId === cpsShareAsset) {
        cpsPathState.value = null
      }
    } else {
      cpsLandingErrorMessage = landingResponse?.msg || 'Failed to parse the link.'
    }
  } catch(e: any) {
    cpsLandingErrorMessage = e?.msg || e?.message || 'Failed to parse the link.'
  }
}

let query = route.query
if(cacheKey) {
  // type/skuId/from 等关键参数只在 url-cache 中，必须完整等待；仅优化为进程内直读，不做超时丢弃
  const res = await ssrMeasure(
    'listing-wap.url-cache',
    { server: process.server },
    async() => {
      if(import.meta.server) {
        return await useRequestEvent()?.context?.readUrlCacheParams?.(cacheKey) ?? null
      }
      return getUrlCache(cacheKey)
    }
  )

  if(res) { query = res }
}
let trafficSourceMeta = buildSourceMetaFromQuery(query as Record<string, unknown>)
let { type, source, skuId, addressId, from, isAd, isNewTag, isChoiceTag, requestId, algorithmModelName } = query

const shareEntrySource = buildShareEntryListingSourceFromQuery(route.query as Record<string, unknown>)
if (shareEntrySource) {
  source = shareEntrySource
  trafficSourceMeta = undefined
}
// 商品详情
const listingDetail = ref<ProductV3.ListingDetailV3>({
  beenFollowed: false,
  listingId: 0,
  selectedSkuId: 0,
  imageUrl: '',
  imageUrls: [],
  title: '',
  shippingType: 0,
  videoUrl: '',
  dashVideoUrl: '',
  faqUrl: '',
  sizeChartPicture: '',
  box: '',
  prepayment: { state: -1, prepaymentRatio: 1, isSupportMergeCommit: false },
  specs: [],
  props: [],
  details: [],
  categoriesPath: [],
  skus: [],
  storeId: 0,
  storeStatus: 1,
  freeShippingPromotion: { name: '', copyWriting: '' },
  crossStoreReduction: [],
  shippingTime: {
    skuId: 0,
    listingId: 0,
    shippingTimeDescription: '',
    agingStart: 0,
    agingEnd: 0,
    logisticsType: 'fbk'
  },
  aftersaleCommitment: {
    exchangePeriod: 0,
    returnRefundPeriod: 0,
    warrantyPeriod: 0,
    support7daysReturn: []
  },
  vouchersInfo: { gens: [], earnedVouchers: [] },
  voucherClaimNotice: null,
  cpsPathToken: null,
  selectedSkuGifts: [],
  selectedSkuActivity: null
})

const showKilimallChoice = computed(() => {
  return Array.isArray(listingDetail.value.highlights)
    && listingDetail.value.highlights.some(item => item.includes('Choice'))
})

const activateDiscount = computed<number>(() => {
  if(!skuActivateInfo.value) {
    return 0
  }

  const { activityPrice } = skuActivateInfo.value
  const { listPrice } = skuPrice.value

  const _price = listPrice - activityPrice
  const discountPrice: number = NP.divide(_price, listPrice) * 100

  const _p = Number((discountPrice >= 0.2 ? discountPrice : _price))

  return Math.floor(_p)
})

// skus
const skus = ref<ProductV3.Sku[]>([])
const userAddressList = ref<Address.IAddressItem[]>([])
const userSelectAddressId = ref<number>(addressId ? Number(addressId) : -1)

const selectedAddress = computed<Address.IAddressItem | undefined>(
  () => {
    const addr = userAddressList.value.find((c: Address.IAddressItem) => c.id === userSelectAddressId.value)
    return addr
  }
)
const flashSaleOutStockTips = computed<string>(() => {
  if(skuActivateInfo.value?.activityType !== 1) {
    return ''
  }

  const { inventory, status } = skuActivateInfo.value.flashSale
  if(status !== 1) {
    return ''
  }

  const { gsAvailable, dsAvailable, fbkAvailable } = inventory

  if(Math.max(gsAvailable,dsAvailable,fbkAvailable) <= 0) {
    return 'This flash sales product is out of stock right now.'
  }

  return ''
})

const headers = useRequestHeaders()
const proto = headers['x-forwarded-proto'] || 'https'
const host = `${proto}://${process.server ? headers.host : window.location.host}`

// Store 信息
const storeInfo = ref<Store.IResult>()
// 物流时效信息
const deliveryInfo = ref<ProductV3.ShippingTime>()
const deliveryCardInfo = computed(() => ({ ...listingDetail.value.aftersaleCommitment, ...deliveryInfo.value }))
const currentSkuId = ref<number>(0)
const currentSelectedSKU = computed<ProductV3.Sku | undefined>(() => skus.value.find((c: ProductV3.Sku) => c.skuId === currentSkuId.value))
// 商品类型：0 普通商品  1： 秒杀商品
const isFlashSaleSku = from === 'flash-sale'
const detailType: 'sku' | 'listing' = type === 'sku' || from === 'sku' || isFlashSaleSku ?  'sku' : 'listing'
// Sku 价格
const skuPrice = computed(() => initSkuPrice(currentSelectedSKU.value))
const skuActivateInfo = ref<ProductV3.SelectedSkuActivity>()

// 极速引流版：与 HeaderBar 浮窗共用同一套 deep link
const wapListingDetailVersion = useWapListingDetailVersionState()
const isExtremeDiversion = computed(() => !isCps.value && wapListingDetailVersion.value === '2')
const { getDeepLinkUrl, handleOpenAppClick } = useProductDeepLink(
  () => currentSelectedSKU.value ? currentSelectedSKU.value.skuId : listingDetail.value.listingId,
  () => skuActivateInfo.value?.activityType === 1 ? 1 : 0,
  () => ({
    source: baseTrackData.value.source,
    trafficSourceMeta: baseTrackData.value.trafficSourceMeta,
  }),
)
const voucherDeepLinkUrl = getDeepLinkUrl('voucher')
const reviewsDeepLinkUrl = getDeepLinkUrl('reviews')
const descriptionDeepLinkUrl = getDeepLinkUrl('description')

// 当前选中的 SKU ID
const specsPreview = ref<string>('')
const specsKeyPreview = ref<string>('')
watch(
  ()=> specsKeyPreview.value,
  (val: string) => {
    updateStatus(
      { 
        // skuId: currentSkuId.value,
        skuKey: val,
        skus: skus.value,
        specs: listingDetail.value.specs
      },
      skuActivateInfo.value
    )
  }
)

const trackError = (e: any) => {
  process.client && $sensors.track(
    $SENSORS_EVENT.goodsDetailsScreen,
    {
      verificationStatus: e.code === '0',
      failureType: e.code,
      failureReason: e.msg,
      listing_id: listingDetail.value?.id || '',
      sku_id: currentSkuId.value || '',
      ...$getExternalLastTrafficSource()
    }
  )
}

/** 赠品信息 - START */
const gifts = ref<IGifts[]>([])
let giftRequest = 0
const initGift = async() => {
  const token = purchaseRequests.capture(), request = ++giftRequest
  gifts.value = []
  if (!currentSelectedSKU.value?.haveGift) return
  try {
    const { giftActivities = [] } = await nuxtApp.runWithContext(() => getGiftsBySkuId(token.skuId))
    if (purchaseRequests.isCurrent(token) && request === giftRequest) gifts.value = giftActivities
  } catch { /* Gifts are optional; stale results must never replace the current selection. */ }
}
/** 赠品信息 - END */

/** 初始化 大促 / 满减 信息 */
const promotionInfo = reactive<ProductV2.IPromotion>({
  bigPromotion: [],
  freeShippingPromotion: {}
})
const initPromotion = async() => {
  const { crossStoreReduction, freeShippingPromotion } = listingDetail.value
  
  promotionInfo.freeShippingPromotion = freeShippingPromotion
  promotionInfo.bigPromotion = crossStoreReduction
}

/** 图文详情 START */
const listingDescription = ref<any[]>([])
const specification = ref<{ name: string, value: string[] }[]>([])
const initListingDescription = () => {
  const { props: detailProps, details} = listingDetail.value

  specification.value = (detailProps || []).map(c => ({ name: c.name, value: c.values.map(c => c.value) }))
  listingDescription.value = details || []
}
/** 图文详情 END */

interface IGetListingDetailV2 {
  productId?: number | string
  skuId?: number | string
  source?: 0 | 1
  traffic_source_tracking?: string
}
const trafficSourceTracking = buildTrafficSourceTracking({
  source: source as string,
  trafficSourceMeta,
  isAd,
  isNewTag: !!isNewTag,
  isChoiceTag: !!isChoiceTag,
  requestId: requestId as string,
  algorithmModelName: algorithmModelName as string
})
const paramsV2:IGetListingDetailV2  = {
  source: isFlashSaleSku ? 1 : 0,
  skuId: skuId ? Number(skuId) : undefined,
  traffic_source_tracking: trafficSourceTracking
}
const cpsGoodsDetailHeaders: Record<string, string> = cpsShareAsset
  ? { 'Pfx-CPS-Channel-Entry': 'true' }
  : {}
if (cpsShareAsset && cpsPathToken) {
  cpsGoodsDetailHeaders['Pfx-CPS-Path-Token'] = cpsPathToken
}
if(detailType === 'sku') {
  paramsV2.skuId = Number(id)
} else {
  paramsV2.productId = Number(id)
}

/** 仅获取类目路径结构化数据；Google JSON-LD 须在 setup 顶层调用（避免 await 后丢失 Nuxt 上下文） */
const initCategoryPaths = async(): Promise<{ name: string, position: number, item: string, '@type': 'ListItem' }[]> => {
  try{
    const cid = listingDetail.value.categoriesPath.slice(-1)[0].id
    const categoryPathTask = ssrMeasure<any[]>(
      'listing-wap.ctg-path',
      { server: process.server },
      () => getCtgPathByCid(cid) as Promise<any[]>
    )
    const ctgPath = await categoryPathTask
    
    const structuredItems: { name: string, position: number, item: string, '@type': 'ListItem' }[] = [];


  (ctgPath || []).forEach((c: any, index: number) => {
    const { id, name } = c
    const path = `${host}/category/${$formatStringToURL(name)}?id=${id}&form=category`

    structuredItems.push({ name, position: index + 2, item: path, '@type': 'ListItem' })
  })

  return structuredItems
  } catch(e) {
    console.error(`[initCategoryPaths]sku#: ${currentSkuId.value}: `, e) // JSON.stringify(e))
    return []
  }
}

let listingResultV2: any = null
let error: any = null
let retried = false
try {
  listingResultV2 = await ssrMeasure(
    'listing-wap.goods-detail',
    { server: process.server, retried: false },
    () => getListingByIdV2(paramsV2, false, cpsGoodsDetailHeaders)
  )
} catch(e) {
  // 如果是listing详情报错了，进行 skuid 详情重试
  if(!paramsV2.skuId && paramsV2.productId) {
    retried = true
    paramsV2.skuId = paramsV2.productId
    paramsV2.productId = ''

    listingResultV2 = await ssrMeasure(
      'listing-wap.goods-detail',
      { server: process.server, retried: true },
      () => getListingByIdV2(paramsV2, true, cpsGoodsDetailHeaders)
    ).then((r: any) => {
        type = 'sku'

        return r
      }).catch((e: any) => {
        error = e
      })
  } else {
    error = e
  }
}
if(!listingResultV2) {
  const failure = classifyGoodsDetailFailure(error)
  const throwData = {
    statusCode: failure.statusCode,
    message: '',
    fatal: failure.expected ? process.client : true
  }
  
  // 违规下架
  if(failure.code === 5004) {
    throwData.message = 'The product does not exist.'
  }
  if(failure.expected) {
    if(Math.random() < 0.01) {
      console.info('[goods-detail] expected outcome:', {
        code: failure.code,
        status: failure.statusCode,
        retried,
        requestType: type
      })
    }
  } else {
    console.error('getListingByIdV2 ERROR: ', {
      code: failure.code,
      retried,
      error
    })
  }
  
  throw createError(throwData)
}

listingDetail.value = listingResultV2
console.log();

const clsId = computed(() => {
  if (listingDetail.value && listingDetail.value.categoriesPath && listingDetail.value.categoriesPath.length) {
    const id = listingDetail.value.categoriesPath.slice(-1)[0]?.id
    return id
  }
  return 0
})
const { selectedSkuId, skus: skusV2, selectedSkuGifts, selectedSkuActivity, shippingTime, aftersaleCommitment } = listingDetail.value
skus.value = skusV2 || []
deliveryInfo.value = shippingTime
skuActivateInfo.value = selectedSkuActivity!

if(detailType === 'sku') {
  currentSkuId.value = Number(id)
} 
if(skuId) {
  if(skusV2.findIndex(c => c.skuId === Number(skuId)) >= 0) {
    currentSkuId.value = Number(skuId)
  }
}

if(currentSkuId.value <= 0) {
  currentSkuId.value = initSkuId(selectedSkuId, skusV2) || 0
}

gifts.value = selectedSkuGifts || []

initListingDescription()
initPromotion()
try {
  const { data: seoData } = await useAsyncData(
    `listing-seo:${useCurrentCountry().value}:${listingDetail.value.listingId}:${currentSkuId.value}`,
    async () => {
      const [structuredItems, googleStructuredData] = await Promise.all([
        initCategoryPaths(),
        ssrMeasure('listing-wap.google-sd', { server: process.server }, () =>
          getGoodsGoogleStructuredData({
            listing_id: listingDetail.value.listingId,
            sku_id: currentSkuId.value || undefined
          }).catch((e: any) => {
            console.error('[getGoodsGoogleStructuredData] wap:', e)
            return null
          }))
      ])
      return { structuredItems, googleStructuredData }
    }
  )
  if (seoData.value) {
    setStructuredData(seoData.value.googleStructuredData, seoData.value.structuredItems)
  }
} catch(e) {
  console.error(`[structuredData]sku#: ${currentSkuId.value}: `, e)
}
// 图片
// 初始化 SKU 图片(含Color的规格才会显示图片)
const colorSpec = listingDetail.value.specs.find(v=> v.name.toUpperCase().indexOf('COLOR') >= 0)

if(colorSpec) {
  const { values, pid } = colorSpec
  values.forEach(val => {
    const _sku = skus.value.find((c: ProductV3.Sku) => c.key.indexOf(`${pid}:${val.pvid}`) >= 0)

    if(_sku && _sku.images?.length > 0) {
      val.image = _sku.images[0] || ''
    }
  }) 
}
/** SEO */
setSEOMeta(listingDetail.value, skuPrice.value)

/** 初始化默认价格 END */

/** 地址和时效信息 START */
const quantity = ref(1)
const purchaseRequests = usePurchaseRequests({
  listing: listingDetail, sku: currentSelectedSKU, skuId: currentSkuId,
  activity: skuActivateInfo, quantity, address: selectedAddress, delivery: deliveryInfo,
  fetchInventory: (id) => nuxtApp.runWithContext(() => getInventoryBySkuId(id, {
    ...(isFlashSaleSku ? { activity_type: 1 } : {}),
    ...(route.query.activateId ? { activate_id: route.query.activateId as string } : {})
  })),
  fetchShipping: (params) => nuxtApp.runWithContext(() => getShippingTime(params))
})
const { inventoryStatus } = purchaseRequests
const retryInventory = async() => {
  giftRequest++
  gifts.value = []
  const token = purchaseRequests.capture()
  const ready = await updateSkuInventory()
  if (!ready || !purchaseRequests.isCurrent(token)) return
  await Promise.all([initDeliveryWarehouse(), initGift()])
  if (purchaseRequests.isCurrent(token) && currentSelectedSKU.value) {
    updateStatus({ skuKey: currentSelectedSKU.value.key, skus: skus.value, specs: listingDetail.value.specs }, skuActivateInfo.value)
  }
}

const handleQuantityChange = (val: number) => { quantity.value = val }
watch(quantity, () => { void initDeliveryWarehouse() }, { flush: 'sync' })

const handleArrivalReminderSuccess = (reminderState: boolean) => {
  const sku = skus.value.find((c: ProductV3.Sku) => c.skuId === currentSkuId.value)
  if(sku) {
    sku.isArrivalReminder = reminderState
  }
}

const initDeliveryWarehouse = () => purchaseRequests.refreshDelivery()
watch(selectedAddress, () => { void initDeliveryWarehouse() })

const handleUpdateSelectAddressId = (id: number) => { userSelectAddressId.value = id }
const userAddressLoading = ref<boolean>(true)
const initUserAddressOr = async() => {
  userAddressLoading.value = true

  if(useUserInfo().value?.accessToken) {
    const res = await getShippingAddress(false).catch((e: any) => { console.error('用户地址初始化异常 >>>>> ', e) })

    userAddressList.value = res || []

    // Match the address popup's availability rules; never auto-select a disabled address.
    const availableAddresses = userAddressList.value.filter((item) =>
      item.status !== 2 && (item.addressType === 2 || !!item.isSupportToDoor)
    )
    if (!availableAddresses.some(item => item.id === userSelectAddressId.value)) {
      const fallbackAddress = availableAddresses.find(item => item.default) || availableAddresses[0]
      userSelectAddressId.value = fallbackAddress?.id ?? -1
    }
  }
  // await initDeliveryWarehouse()
  userAddressLoading.value = false
}
/** 地址和时效信息 END */

/** INIT REVIEWS START */
const reviewTotal = ref<number>(0)
const reviewScore = ref<number>(5)
const reviewsList = ref<any>([])
const initReviews = async() => {
  const [commentStat, commentList] = await Promise.all([
    getCommentStatistics({
      listingId: listingDetail.value.listingId,
      storeId: storeInfo.value!.store.id
    }),
    getCommentList({
      listing_id: listingDetail.value.listingId,
      offset: 0,
      limit: 3,
      order_by: 'top'
    })
  ])
  const ratingTask = () => {
    reviewScore.value = commentStat.listingScore
    storeInfo.value!.store.starRating = commentStat.storeScore
    reviewTotal.value = commentStat.commentTotalNum
  }

  const reviewsTask = () => {
    reviewsList.value = (commentList.items || []).map((c: any) => {
      const timeStr = $tz.zeroToLocalZonetime(new Date(c.commentBase.createdTime), { format: 'yyyy-MM-dd' })
      const timeAry = timeStr.split('-')
      const m = $tz.monthToEn(Number(timeAry[1]))
      timeAry.splice(1, 1, m)

      c.replyTime = `${m} ${timeAry[2]}.${timeAry[0]}`
      return c
    })
  }

  queue.addTask(ratingTask)
  queue.addTask(reviewsTask)
}
/** INIT REVIEWS END */

/** INIT VOUCHERS START */
const listCollected = ref<any[]>([])
const listCollect = ref<any[]>([])
const voucherList = ref<{ show: boolean, list: any[] }>({ show: true, list: [] })

const voucherTask = (voucherResult: any) => {
  const { earnedVouchers = [], gens } = voucherResult  
  earnedVouchers.forEach((c: any) => {
    c.theStartDate = $tz.zeroToLocalZonetime(c.genStartDate, { format: 'dd/MM/yyyy' })
    c.theEndDate = $tz.zeroToLocalZonetime(c.genEndDate, { format: 'dd/MM/yyyy' })
    c.expiredTime = $tz.zeroToLocalZonetime(c.endDate, { format: 'dd/MM/yyyy' })

    listCollected.value.push(c)
  })

  listCollect.value = (gens || []).map((c: any) => {
    c.theStartDate = $tz.zeroToLocalZonetime(c.startDate, { format: 'dd/MM/yyyy' })
    c.theEndDate = $tz.zeroToLocalZonetime(c.endDate, { format: 'dd/MM/yyyy' })

    if(!c.isEarned && c.remainNumber > 0) {
      voucherList.value.list.push(c)
    }

    return c
  })

  if(voucherList.value.list.length <= 0) {
    voucherList.value.show = false
  }
}

const initVouchers = async() => {
  if(skus.value.length <= 0 || skuActivateInfo.value?.flashSale?.noVoucher) {
    voucherList.value.show = false
    voucherList.value.list = []
    return
  }

  const skuIds: number[] = skus.value.map((c: any) => c.skuId).slice(0, 20)
  const { categoriesPath, listingId } = listingDetail.value
  const params: IVoucherParmas = {
    skuIds,
    categoryId: categoriesPath[categoriesPath.length - 1].id,
    storeId: storeInfo.value!.store.id,
    listingId
  }

  const voucherResult = await getVouchersBySkuids(params)
  const _voucherTask = () => voucherTask(voucherResult)
  queue.addTask(_voucherTask)
}

const storeRecommendListings = ref<any>([])
const initStoreRecommendListings = async(storeId: number) => {
  
  const { listings } = await getRecommendedProduct(storeId, false).then((r: any) => r.data)

  queue.addTask(() => { 
    listings.forEach((item: any) => {
      // 埋点名称
      item.source = buildProductDetailStoreSpecifiedSource()
      storeRecommendListings.value.push(item)
    })
  })
}
/** ----------------------- Event handler START ----------------------------------- */
const trackSkuIdMap: { [key:string]: number } = {}
const baseTrackData = computed<ITrackConfig>(() => {
  const categoryId = listingDetail.value.categoriesPath[listingDetail.value.categoriesPath.length - 1]?.id || 0
  return {
    source: source as string,
    trafficSourceMeta,
    skuId: currentSkuId.value,
    listingId: listingDetail.value.listingId || 0,
    categoryId: categoryId || 0,
    store: storeInfo.value?.store,
    skuPrice: skuPrice.value,
    isAd: isAd === 'ad' || isAd,
    isNewTag: !!isNewTag,
    isChoiceTag: !!isChoiceTag || resolveIsChoiceTag(listingDetail.value.highlights),
    requestId: (requestId as string) || '',
    algorithmModelName: (algorithmModelName as string) || '',
    productInventoryType: deliveryInfo.value?.logisticsType!,
    productTitle: listingDetail.value.title
  }
})
const reviewTrafficTrack = computed<ITrafficTrackFields>(() => ({
  source: baseTrackData.value.source,
  isAd: baseTrackData.value.isAd,
  isNewTag: baseTrackData.value.isNewTag,
  isChoiceTag: baseTrackData.value.isChoiceTag,
  requestId: baseTrackData.value.requestId,
  algorithmModelName: baseTrackData.value.algorithmModelName
}))
const handleToReviewsClick = () => {
  router.push({
    path: `/reviews/${listingDetail.value.listingId}`,
    query: trafficTrackToRouteQuery(reviewTrafficTrack.value)
  })
}
const skuTrackFn = () => {
  const token = purchaseRequests.capture()
  const data = { ...baseTrackData.value }
  if (trackSkuIdMap[token.skuId]) return
  queue.addTask(() => {
    if (!purchaseRequests.isCurrent(token) || trackSkuIdMap[token.skuId]) return
    trackFn(data, $SENSORS_EVENT.viewProductDetail)
    trackSkuIdMap[token.skuId] = 1
  })
}

/** 客户端渲染初始化 START */
const clientInit = () => {
  // 提前将无库存的规格标记
  disableOutOfStockSpecs(listingDetail.value.specs, skus.value)
  // 更新与当前选中规格相关规格的状态
  if(currentSelectedSKU.value) {
    updateStatus(
      {
        skuKey: currentSelectedSKU.value.key,
        skus: skus.value,
        specs: listingDetail.value.specs
      },
      skuActivateInfo.value
    )
  }
  
  Promise.all([
    getStoreInfo(listingDetail.value.storeId).then((r: any) => r.data), // 初始化店铺信息
  ]).then(([storeRes]) => {
    storeInfo.value = storeRes

    const _voucherTask = () => voucherTask(listingDetail.value.vouchersInfo)
    queue.addTask(_voucherTask)

    Promise.all([
      initUserAddressOr(), /** 初始化地址及时效信息 */ 
      // initVouchers(), /** 优惠券 */
      initReviews() /** 评论 */
    ])
    if(useIsMobile().value) {
      initStoreRecommendListings(storeRes.store.id)
    }

    skuTrackFn()

    queue.addTask(() => {
      tiktokTrack(
        'ViewContent',
        1,
        currentSelectedSKU.value,
        listingDetail.value
      )
    })
  })
}

if(process.client && listingDetail.value.listingId) {    
  clientInit()
  
  queue.addTask(() => { trackError({ code: '0', msg: 'success' }) })
 
  await initGift()
}
/** 客户端渲染初始化 END */
/** ----------------------- Event handler START ----------------------------------- */
// const handleWishlistTrackFn = (evName: keyof typeof $SENSORS_EVENT) => {
//   const fn = () => {
//     trackFn(baseTrackData.value, evName)
//   }

//   queue.addTask(fn)
// }


const updateSkuInventory = () => purchaseRequests.refreshInventory()

const handleUpdateSkuClick = async(skuKey: string, sku?: ProductV3.Sku) => {
  if(sku?.skuId === currentSkuId.value) {
    return
  }

  currentSkuId.value = sku?.skuId || 0
  gifts.value = []

  if(currentSkuId.value <= 0) { return }

  const token = purchaseRequests.capture()
  const ready = await updateSkuInventory()
  if (!ready || !purchaseRequests.isCurrent(token)) return
  await Promise.all([initDeliveryWarehouse(), initGift()])
  if (!purchaseRequests.isCurrent(token)) return
  updateStatus({ skuKey, skus: skus.value, specs: listingDetail.value.specs }, skuActivateInfo.value)
  skuTrackFn()
}

/** 活动结束 刷新SKU */
const handleActivityOver = (activity: ProductV3.SelectedSkuActivity) => {
  if (!purchaseRequests.expireActivity(activity)) return
  showToast('The current activity has ended.')
  void retryInventory()
}

const skuVisible = ref<boolean>(route.query.openSku === '1')
const skuVisibleType = ref<ProductV2.IOptionType>('order-now')
const handleOrderNowClick = (type: ProductV2.IOptionType) => {
  skuVisibleType.value = type
  skuVisible.value = true
}

const handleTokfClick = () => {
  if(!useUserInfo().value?.userId) {
    return router.push(`/login?redirect=${encodeURI(route.fullPath)}`)
  }

  let { listingId: id, imageUrl, title } = listingDetail.value
  if(currentSelectedSKU.value) {
    imageUrl = currentSelectedSKU.value.images[0] || imageUrl
  }

  const { id: storeId, name, storeIcon } = storeInfo.value!.store

  let _price = skuPrice.value.salePrice || ''
   
  if(skuActivateInfo.value && [1, 4, 6].includes(skuActivateInfo.value?.activityType)){
    const { startTime, endTime } = skuActivateInfo.value
    const st = new Date(startTime).getTime()
    const et = new Date(endTime).getTime()
    const curT = new Date().getTime()
    
    if(curT >= st && curT <= et) {
      _price = skuActivateInfo.value?.activityPrice
    }
  }
  const productMsg: Msg.IMsgProduct = {
    goodsId: id,
    goodsName: title,
    goodsPic: imageUrl || 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
    goodsUnit: !currentSelectedSKU.value?.inventory ? 'Out of stock' : $currencySymbol(),
    goodsPrice: _price,
    storeId: storeId,
    storeName: name,
    storeIcon,
    source: toLiveChatSource(source as string, trafficSourceMeta)
  }

  router.push({ path: '/message/store-chat', query: { ...productMsg, chat_first_page: 'productDetail' } })
}

const addressPopupShow = ref<boolean>(false)
const handleSwitchAddressClick = () => {
  if(!useUserInfo().value?.accessToken) {
    return router.push(`/login?redirect=${encodeURI(route.fullPath)}`)
  }

  addressPopupShow.value = true
}

const handleReviewsViewAllClick = () => {
  router.push(`/reviews/${listingDetail.value.listingId}`)
}

const couponPopupShow = ref<boolean>(false)
const handleShowVoucherClick = () => {
  if (isExtremeDiversion.value) {
    window.location.href = voucherDeepLinkUrl.value
    handleOpenAppClick()
    return
  }
  couponPopupShow.value = true
}
const handleUpdateVoucher= async(voucher:any, index:number) => {
  await initVouchers()
}

const isShowOpenAppBar = ref<boolean>(false)
const handleUpdateShowBarChange = (e: boolean) => {
  isShowOpenAppBar.value = e
}

const handleAddressClick = () => {
  const { path, query } = route
  const newURL = router.resolve({ path, query: { ...query, openSku: 1 }}).href

  router.push({ path: '/address/add', query: { redirect: encodeURIComponent(newURL) }})
}

const handleAddWishClick = (e: boolean) => {
  listingDetail.value.beenFollowed = e

  if(e) {
    queue.addTask(() => { trackFn(baseTrackData.value, $SENSORS_EVENT.addToFavorites)})

    queue.addTask(() => {
      tiktokTrack(
        'AddToWishlist',
        1,
        currentSelectedSKU.value,
        listingDetail.value
      )
    })
  }
}
// 商品的品类数组
const categoryList: Ref<Array<number>> = ref([])
onMounted(() => {
  if (listingDetail.value && listingDetail.value.categoriesPath && Array.isArray(listingDetail.value.categoriesPath)) {
    // 提取 id 并去重
    const ids = listingDetail.value.categoriesPath.map((item: any) => item.id)
    categoryList.value = [...new Set(ids)]
    const listingCategoryItem: IListingCategoryItem = {
      listingId: listingDetail.value.listingId,
      categoryList: categoryList.value,
      timestamp: Date.now()
    }
    setReviewListingIdCategoryList(listingCategoryItem)
  }
})
</script>

<style lang="scss" scoped>
.content-wrapper{
  background-color: #f5f5f5;
  border-radius: 20px;
  padding: 1px 0;
}
.find-more-details,
.find-more-reviews {
  justify-content: start;
  display: flex;
  align-items: center;
  text-align: left;
  font-size: 24px;
  color: #E14646;
  padding: 0 0 16px;
  text-decoration: none;
  .van-icon{
    margin-left: 4px;
  }
}
.find-more-details {
  justify-content: center;
  padding: 30px 20px;
  margin: 20px;
  font-size: 28px;
  color: var(--default_color);
  border-radius: 100px;
}
.swiper-box{
  position: relative;
  width: 100%;
  height: 100vw;
  .back{
    position: absolute;
    left: 20px;
    bottom: 630px;
    display: flex;
    align-items: center;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    cursor: pointer;
    background-color: rgba($color: #000, $alpha: 0.3);
    i{ font-size: 42px; margin-left: 12px; }
  }
}
.swiper-box img {
  width: 100vw;
  height: 100vw;
}
:global(html[data-kili-app-entry="browser"] .swiper-box:not(.app-entry-disabled)) {
  margin-top: 122px;
}
.swiper-box-108px{
  padding-top: 100px;
}
.activate-card{
  margin-bottom: -30px;
}

.prepaid-tips{
  color: var(--default_color);
  padding: 4px 0;
  margin: 10px 0;
  font-size: 26px;
  display: inline-block;
}
.store-closed-tips{
  color: #999;
  font-size: 24px;
  font-style: italic;
}

.cell-box{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  .icon{
    color:#b1b1b1;
    font-size: 22px;
    min-width: 40px;
    text-align: right;
    display: flex;
    align-items: center;
    justify-content: right;
  }
  .title{font-size: 32px;font-weight: 600;}
}
.cell-box-bl{
  border-bottom: 0.5px solid #f5f5f5;
}
.sku-cell-box{
  border-top: 0.5px solid #f5f5f5;
}
.box-description{
  padding: 15px;
  font-size: 26px;
  padding-bottom: 30px;
}

.info-card{
  background-color: #fff;
  min-height: 40px;
  border-radius: 12px;
  margin: 15px;
}
.cell-title-card{
  padding: 0 20px; 
}
.address-name{
  display: inline-block;
  max-width: 400px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #333;
  text-shadow: 0 0 1px #333;
}
.basic-info{
  padding: 20px 20px 0 20px;
  .sale-price{
    margin-bottom: 20px;
    font-weight: 600;
    color: var(--default_color);
    font-size: 40px;
  }
  .del-price{
    font-size: 22px;
    color: #999;
    text-decoration: line-through;
    margin: 0 10px;
  }
  .discount{
    font-size: 22px;
    display: inline-block;
    color: var(--pc-default-color);
    margin-left: 10px;
  }
  .product-title{
    margin: 15px 0;
    font-size: 32px;
    line-height: 40px;
    font-weight: 400;
    color: #000;
  }
  .reviews-info{ color: #999; font-size: 28px; }
  .reviews-info .reviews-star::v-deep(.van-rate__icon) {font-size: 28px;;}
  .sku-specs{
    font-weight: 600;
    font-size: 26px;
    overflow: hidden;
  }
  .small-image-box{
    display: flex;
    overflow-y: auto;
    padding-bottom: 20px;
    &::-webkit-scrollbar{
      display: none;
    }
    .small-image{
      width: 160px;
      min-width: 160px;
      height: 160px;
      margin-right: 10px;
      border: 3px solid transparent;
      border-radius: 2px;
      overflow: hidden;
      img{
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
    .small-image[select="1"]{
      border-color: var(--default_color);
    }
  }
}

// .delivery-infos{ min-height: 0px; }

.review-list::v-deep(.reviews-item){
  margin: 0;
}
.voucher-list{
  min-height: 65px;
  padding-top: 0;
  .icon{
    color: #333;
    font-size: 24px;
    i {
      color: #b1b1b1;
    }
  }
  .voucher{
    display: inline-block;
    // border: 1px solid var(--default_color);
    min-width: 160px;
    text-align: center;
    height: 44px;
    color: var(--default_color);
    line-height: 44px;
    margin-right: 20px;
    border-radius: 2%;
    font-size: 24px;
    background: url('https://image.kilimall.com/c/h5/imgs/ic_coupon_kilimall.png');
    background-size: 100% 100%;
  }
}
.gifts{
  padding-bottom: 20px;
}

.store-card-box{
  border-bottom: 0.5px solid #f5f5f5;
}
.recommend-product-box{
  background-color: transparent;
  padding: 0;
  margin-bottom: 230px;
}
</style>
